import store from "@/redux/store";
import React, { useEffect } from "react";
import { Provider } from "react-redux";
import RouterComponent from "@/router";
import { Button, Result } from "antd";
import useNetwork from "@/hooks/useNetwork";
import { ACCESS_TOKEN_NAME } from "@/config/serverApiConfig";
import { logout } from "@/auth";
import storePersist from "@/redux/storePersist";

function App() {
  const { isOnline: isNetwork } = useNetwork();
  useEffect(() => {
    const _remember = storePersist.get("remember");
    if (_remember === false && !sessionStorage.getItem(ACCESS_TOKEN_NAME)) {
      logout();
      window.location.href = "/login";
    }
  }, []);
  if (!isNetwork)
    return (
      <>
        <Result
          status="404"
          title="No Internet Connection"
          subTitle="Check your Internet Connection or your network."
          extra={
            <Button href="/" type="primary">
              Try Again
            </Button>
          }
        />
      </>
    );
  else {
    return (
      <div className="notranslate" translate="no">
        <Provider store={store}>
          <RouterComponent />
        </Provider>
      </div>
    );
  }
}

export default App;
